var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"feedback-btn",staticClass:"general-btn",class:[
    _vm.type + '-btn',
    _vm.color + '-btn',
    _vm.inactive ? _vm.color + '-inactive-btn' : '',
    this.$mq === 's' ? 'text-h5' : ''
  ]},[_vm._t("default",[_vm._v(_vm._s(_vm.type === "submit" ? "Отправить" : ""))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }